import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';
import { AppMenu } from './app.menu';
import { AppMenuService } from '../service/menu.service';
import { LayoutService } from '../service/layout.service';
import { AuthService } from '@/app/core';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [CommonModule, RouterModule, AppMenu, RippleModule, TooltipModule],
    template: `
        <div class="layout-sidebar" [class.compact]="isCompact">

            <!-- Header: botón hamburger -->
            <div class="sidebar-header">
                <button class="sidebar-hamburger"
                        (click)="layoutService.onMenuToggle()"
                        type="button"
                        aria-label="Abrir / cerrar menú">
                    <span class="pi pi-bars"></span>
                </button>
            </div>

            <!-- Área scrollable de navegación -->
            <div class="sidebar-nav">
                <app-menu [model]="menu"></app-menu>
            </div>

            <!-- Sección inferior fija -->
            <div class="sidebar-bottom">

<!--                 <a class="bottom-item"
                   [routerLink]="['/ayuda']"
                   routerLinkActive="active-route"
                   pRipple
                   pTooltip="Ayuda"
                   tooltipPosition="right"
                   [tooltipDisabled]="!isCompact">
                    <span class="active-bar"></span>
                    <i class="pi pi-question-circle layout-menuitem-icon" aria-hidden="true"></i>
                    <span class="layout-menuitem-text">Ayuda</span>
                </a> -->

<!--                 <a class="bottom-item"
                   [routerLink]="['/tickets']"
                   routerLinkActive="active-route"
                   pRipple
                   pTooltip="Tickets"
                   tooltipPosition="right"
                   [tooltipDisabled]="!isCompact">
                    <span class="active-bar"></span>
                    <i class="pi pi-ticket layout-menuitem-icon" aria-hidden="true"></i>
                    <span class="layout-menuitem-text">Tickets</span>
                </a> -->

                <a class="bottom-item"
                   [routerLink]="['/notificaciones']"
                   routerLinkActive="active-route"
                   pRipple
                   pTooltip="Notificaciones"
                   tooltipPosition="right"
                   [tooltipDisabled]="!isCompact">
                    <span class="active-bar"></span>
                    <i class="pi pi-bell layout-menuitem-icon" aria-hidden="true"></i>
                    <span class="layout-menuitem-text">Notificaciones</span>
                </a>

                <div class="bottom-divider"></div>

                <a class="bottom-item logout-item"
                   (click)="logout()"
                   (keydown.enter)="logout()"
                   tabindex="0"
                   pRipple
                   pTooltip="Cerrar sesión"
                   tooltipPosition="right"
                   [tooltipDisabled]="!isCompact">
                    <span class="active-bar"></span>
                    <i class="pi pi-sign-out layout-menuitem-icon" aria-hidden="true"></i>
                    <span class="layout-menuitem-text">Cerrar sesión</span>
                </a>

            </div>
        </div>
    `
})
export class AppSidebar {
    menu: MenuItem[] = [];

    readonly layoutService = inject(LayoutService);
    private readonly menuService = inject(AppMenuService);
    private readonly auth = inject(AuthService);
    private readonly router = inject(Router);

    get isCompact(): boolean {
        return this.layoutService.layoutState().staticMenuDesktopInactive === true;
    }

    ngOnInit() {
        this.menu = this.menuService.getMenuItems();
    }

    logout() {
        this.auth.logout();
    }
}
